module.exports = __webpack_public_path__ + "img/IMG_8987.36f67090.jpg";